var isArrayLike = require('./type/is-array-like');

function toArray(value) {
  return isArrayLike(value) ? Array.prototype.slice.call(value) : [];
}

module.exports = toArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/to-array.js
// module id = 29
// module chunks = 0 1 2